import { Injectable } from '@angular/core';

import { SecurityService } from '../services/security.service';
import { AuthenticationState } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardNoAccountsService {
  constructor(private securityService: SecurityService) {}

  async canActivate(): Promise<boolean> {
    if (this.securityService.accountIsVerified || this.securityService.authenticationState === AuthenticationState.noAccounts) {
      return true;
    }

    await this.securityService.startAuthentication();
    return false;
  }
}
